import z from 'zod';

// in zod v4 we can do this: export const SortOrderSchema = z.enum(SortOrder);
// sadly we are using v3 :(
export const SortOrderSchema = z.union([z.literal(1), z.literal(-1)]);

export const PaginationResultSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    data: z.array(item),
    meta: PaginationMetadataSchema,
  });

export const PaginationMetadataSchema = z.object({
  current_page: z.number(),
  first_page: z.number(),
  last_page: z.number(),
  per_page: z.number(),
  total: z.number(),
});

export const SortBySchema = <T extends z.ZodRawShape>(
  schema: z.ZodObject<T>,
  excludeFields: (keyof T)[] = []
) => {
  const keys = Object.keys(schema.shape).filter(key => !excludeFields.includes(key as keyof T));
  return z.enum(keys as [string, ...string[]]);
};
export const BasePaginationAndSearchSchema = <K extends z.ZodTypeAny>(sortByKeySchema: K) =>
  z.object({
    search: z.string().optional(),
    page: z.coerce.number(),
    perPage: z.coerce.number(),
    sortBy: sortByKeySchema.optional(),
    sortDirection: SortOrderSchema.optional(),
  });

export type PaginationMetadata = z.infer<typeof PaginationMetadataSchema>;
